import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlatformWidgetComponent } from '../platform-widget.component';
import { TranslocoModule } from '@jsverse/transloco';
import { MarkantElementsModule } from '@markant/elements-angular';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'markant-platform-service-catalog-widget',
  standalone: true,
  templateUrl: './service-catalog-widget.component.html',
  styleUrls: ['./service-catalog-widget.component.scss'],
  imports: [TranslocoModule, MarkantElementsModule, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceCatalogWidgetComponent extends PlatformWidgetComponent {}
